<script lang="ts" setup>
    import SearchMultipleBase from '../components/Search/SearchMultipleBase.vue'
    import SearchPatient from '../components/Search/SearchPatient.vue'
    import SearchPayer from '../components/Search/SearchPayer.vue'
    import SearchResource from '../components/Search/SearchResource.vue'
    import SearchDocumentFolder from '../components/Search/SearchDocumentFolder.vue'
    import SearchUserGroup from '../components/Search/SearchUserGroup.vue'
    import SearchApptTypeProcedure from '../components/Search/SearchApptTypeProcedure.vue'
    import SearchProcedureCode from '../components/Search/SearchProcedureCode.vue'
    import SearchProvider from '../components/Search/SearchProvider.vue'
    import SearchLoinc from '../components/Search/SearchLoinc.vue'
    import SearchServiceLocation from '../components/Search/SearchServiceLocation.vue'
    import SearchUserGroupMultiple from '../components/Search/SearchUserGroupMultiple.vue'
    import SearchEDocuments from '../components/Search/SearchEDocuments.vue'
    import SearchSoapNotes from '../components/Search/SearchSoapNotes.vue'
    import SearchPatientOrderResults from '../components/Search/SearchPatientOrderResults.vue'
    import { onMounted, ref, reactive } from 'vue';
    import { DatabaseIdTypes, MenuNameType, AppScreenNames, ListNames, UserGroupType } from "../Enums/ChoiceEnums";
    import { ISearchPatientItem, ISearchPatientKey, ISearchPayerItem, ISearchPayerKey, ISearchResourceItem, ISearchResourceKey, ISearchDocumentFolderItem, ISearchDocumentFolderKey, ISearchUserGroupKey, ISearchUserGroupItem, ISearchBaseInputs, IListByNameItem, IListByNameExtended, ISearchBaseKey, ISearchLoincKey } from '../lib/Models/SearchModel';
    import { patient, IApptTypeSearchKey, ICodeSearchKey, IServiceLocationSearchKey, IProviderSearchKey } from "../lib/ChoiceApi";
    import { ISearchDocumentResult } from '../lib/Api/DocumentManager';
    import { IPatientSoapNotesItem } from '../lib/Models/SoapNotes';
    import { ISearchPatientTestResultsItem } from '../lib/Api/EmrOrderEntry';

    interface ISearchGalleryResult {
        result1: string,
        result2: string,
        key: ISearchBaseKey
    }


    const searchResults = ref<ISearchPatientItem[]>([]);
    const displayErrorMessage = ref<boolean>(false);

    const searchPatientResults = ref<string>("");
    const searchPayerResults = ref<string>("");
    const searchResourceResults = ref<string>("");
    const searchFolderResults = ref<string>("");
    const searchUserGroupResults = ref<string>("");
    const searchApptTypeProcedureResults = ref<string>("");
    const searchProcedureCodeResults = ref<string>("");
    const searchProviderResults = ref<string>("");
    const searchLoincResults = ref<string>("");
    const searchServiceLocationResults = ref<string>("");
    const searchUserGroupMultipleReviewedByResults = ref<string>("");
    const searchUserGroupMultipleMailResults = ref<string>("");
    const folderMenuId = ref<MenuNameType>(MenuNameType.Patient);
    const defaultPatientKey = ref<ISearchPatientKey>();
    const defaultPayerKey = ref<ISearchPayerKey>();
    const defaultResourceKey = ref<ISearchResourceKey>();
    const defaultFolderKey = ref<ISearchDocumentFolderKey>();
    const defaultUserGroupKey = ref<ISearchUserGroupKey>();
    const defaultApptTypeProcedureKey = ref<IApptTypeSearchKey>();
    const defaultCodeKey = ref<ICodeSearchKey>();
    const defaultServiceLocationKey = ref<IServiceLocationSearchKey>();
    const defaultProviderKey = ref<IProviderSearchKey>();
    const defaultLoincKey = ref<ISearchLoincKey>();

    const compData = reactive<{
        eDocsSearch:
        {
            result?: ISearchDocumentResult
        },
        soapNotesSearch:
        {
            result?: IPatientSoapNotesItem
        },
        EmrOrderEntry:
        {
            result?: ISearchPatientTestResultsItem
        }
    }>({
        eDocsSearch:{},
        soapNotesSearch: {},
        EmrOrderEntry: {}
    });

    const searchColumns = ref([
        { title: "Chart #", element: "patient_id" },
        { title: "Name", element: "patient_name" },
        { title: "Gender", element: "gender" },
        { title: "Birth Date", element: "birth_date" },
        { title: "Age", element: "age" },
      ]);

    onMounted(async () => {
    });

    // Computed
    

    // Functions
    function onChangePatient(patient: ISearchPatientItem) {
        searchPatientResults.value = JSON.stringify(patient);
    }

    function onChangePayer(payer: ISearchPayerItem) {
        searchPayerResults.value = JSON.stringify(payer);
    }

    function onChangeResource(resource: ISearchResourceItem) {
        searchResourceResults.value = JSON.stringify(resource);
    }

    function onChangeFolder(folder: ISearchDocumentFolderItem) {
        searchFolderResults.value = JSON.stringify(folder);
    }


    function onChangeUserGroup(userGroup: ISearchUserGroupItem) {
        searchUserGroupResults.value = JSON.stringify(userGroup);
    }

    function onChangeApptTypeProcedure(apptTypeProcedure: unknown) {
        searchApptTypeProcedureResults.value = JSON.stringify(apptTypeProcedure);
    }

    function onChangeProcedureCode(result: unknown) {
        searchProcedureCodeResults.value = JSON.stringify(result);
    }

    function onChangeServiceLocation(result: unknown) {
        searchServiceLocationResults.value = JSON.stringify(result);
    }

    function onChangeProvider(result: unknown) {
        searchProviderResults.value = JSON.stringify(result);
    }

    function onChangeLoinc(result: unknown) {
        searchLoincResults.value = JSON.stringify(result);
    }

    function onChangeMultipleBase(patient: ISearchPatientItem) {
    }

    function onSelectUserGroupMultipleReviewedBy(selectedResults: IListByNameExtended[]) {
        searchUserGroupMultipleReviewedByResults.value = JSON.stringify(selectedResults);
    }

    function onSelectUserGroupMultipleMail(selectedResults: IListByNameExtended[]) {
        searchUserGroupMultipleMailResults.value = JSON.stringify(selectedResults);
    }

    async function performSearch(inputs: ISearchBaseInputs) {
        const respSearch = await patient.search(inputs);
        searchResults.value = respSearch?.searchList ?? [];
    }

    function SetPatientKey(test: number) {
        switch (test) {
            case 1:
                defaultPatientKey.value = {
                    patientId: 311786
                }
                break;
            case 2:
                defaultPatientKey.value = {
                    patientId: 311786,
                    display: "Test Patient"
                }
                break;
            case 3:
                defaultPatientKey.value = {
                    searchText: "test"
                }
                break;
            case 4:
                defaultPatientKey.value = {
                    patientId: undefined
                }
                break;
        }
    }

    function SetPayerKey(test: number) {
        switch (test) {
            case 1:
                defaultPayerKey.value = {
                    payerEid: 36303
                }
                break;
            case 2:
                defaultPayerKey.value = {
                    payerEid: 36303,
                    display: "Test Payer"
                }
                break;
            case 3:
                defaultPayerKey.value = {
                    searchText: "test"
                }
                break;
            case 4:
                defaultPayerKey.value = {
                    payerEid: undefined
                }
                break;
        }
    }

    function SetResourceKey(test: number) {
        switch (test) {
            case 1:
                defaultResourceKey.value = {
                    resourceEid: 39783
                }
                break;
            case 2:
                defaultResourceKey.value = {
                    resourceEid: 39783,
                    display: "Test Payer"
                }
                break;
            case 3:
                defaultResourceKey.value = {
                    searchText: "test"
                }
                break;
            case 4:
                defaultResourceKey.value = {
                    resourceEid: undefined
                }
                break;
        }
    }

    function SetFolderKey(test: number) {
        switch (test) {
            case 1:
                defaultFolderKey.value = {
                    menuId: 522
                }
                break;
            case 2:
                defaultFolderKey.value = {
                    menuId: 522,
                    display: "Test Folder"
                }
                break;
            case 3:
                defaultFolderKey.value = {
                    searchText: "test"
                }
                break;
            case 4:
                defaultFolderKey.value = {
                    menuId: undefined
                }
                break;
        }
    }

    function SetUserGroupKey(test: number) {
        switch (test) {
            case 1:
                defaultUserGroupKey.value = {
                    optionalIdentifier: UserGroupType.User,
                    identifier: 251
                }
                break;
            case 2:
                defaultUserGroupKey.value = {
                    optionalIdentifier: UserGroupType.User,
                    identifier: 251,
                    display: "Test User"
                }
                break;
            case 3:
                defaultUserGroupKey.value = {
                    searchText: "test"
                }
                break;
            case 4:
                defaultUserGroupKey.value = {
                }
                break;
        }
    }

    function SetApptTypeProcedureKey(test: number) {
        switch (test) {
            case 1:
                defaultApptTypeProcedureKey.value = {
                }
                break;
            case 2:
                defaultApptTypeProcedureKey.value = {
                    display: "This is an appointment type"
                }
                break;
            case 3:
                defaultApptTypeProcedureKey.value = {
                    searchText: "test"
                }
                break;
            case 4:
                defaultApptTypeProcedureKey.value = {
                }
                break;
        }
    }

    function SetCodeKey(test: number) {
        switch (test) {
            case 1:
                defaultCodeKey.value = {
                }
                break;
            case 2:
                defaultCodeKey.value = {
                    display: "This is a code"
                }
                break;
            case 3:
                defaultCodeKey.value = {
                    searchText: "test"
                }
                break;
            case 4:
                defaultCodeKey.value = {
                }
                break;
        }
    }

    function SetServiceLocationKey(test: number) {
        switch (test) {
            case 1:
                defaultServiceLocationKey.value = {
                }
                break;
            case 2:
                defaultServiceLocationKey.value = {
                    display: "This is a service location"
                }
                break;
            case 3:
                defaultServiceLocationKey.value = {
                    searchText: "test"
                }
                break;
            case 4:
                defaultServiceLocationKey.value = {
                }
                break;
        }
    }

    function SetProviderKey(test: number) {
        switch (test) {
            case 1:
                defaultProviderKey.value = {
                }
                break;
            case 2:
                defaultProviderKey.value = {
                    display: "This is a provider"
                }
                break;
            case 3:
                defaultProviderKey.value = {
                    searchText: "test"
                }
                break;
            case 4:
                defaultProviderKey.value = {
                }
                break;
        }
    }

    function SetLoincKey(test: number) {
        switch (test) {
            case 1:
                defaultLoincKey.value = {
                }
                break;
            case 2:
                defaultLoincKey.value = {
                    display: "This is a loinc"
                }
                break;
            case 3:
                defaultLoincKey.value = {
                    searchText: "test"
                }
                break;
            case 4:
                defaultLoincKey.value = {
                }
                break;
        }
    }

</script>

<template>
    <div class="row mt-2">
        <SearchEDocuments :idType="DatabaseIdTypes.patient_id" :id="312213" :defaultDaysSinceCreated="360" @onChange="result => compData.eDocsSearch.result = result" />
        <div v-if="compData.eDocsSearch.result">
            {{compData.eDocsSearch.result}}
        </div>
    </div>

    <div class="row mt-2">
        <SearchSoapNotes 
                :idType="DatabaseIdTypes.patient_id" 
                :id="312148" 
                :defaultDaysSinceEncounter="360" 
                @onChange="result => compData.soapNotesSearch.result = result" />
        <div v-if="compData.soapNotesSearch.result">
            {{compData.soapNotesSearch.result}}
        </div>
    </div>

    <div class="row mt-2">
        <SearchPatientOrderResults
            :patientId="312010"
            :defaultDaysSinceCollected="180"
            @onChange="result => compData.EmrOrderEntry.result = result"/>

        <div v-if="compData.EmrOrderEntry.result">
            {{compData.EmrOrderEntry.result}}
        </div>            
    </div>

    <div class="row mt-2">
        <div class="col">
            <SearchPatient 
                :defaultSearchKey="defaultPatientKey" 
                @onChange="onChangePatient">
            </SearchPatient>
            {{searchPatientResults}}
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetPatientKey(1)">Set Key By ID</button>
        </div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetPatientKey(2)">Set Key By ID & Name</button>
        </div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetPatientKey(3)">Set Key By Text</button>
        </div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetPatientKey(4)">Set Key Empty</button>
        </div>
    </div>

    <div class="row mt-2">
        <div class="col">
            <SearchPayer 
                :defaultSearchKey="defaultPayerKey" 
                @onChange="onChangePayer">
            </SearchPayer>
            {{searchPayerResults}}
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetPayerKey(1)">Set Key By ID</button>
        </div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetPayerKey(2)">Set Key By ID & Name</button>
        </div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetPayerKey(3)">Set Key By Text</button>
        </div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetPayerKey(4)">Set Key Empty</button>
        </div>
    </div>

    <div class="row mt-2">
        <div class="col">
            <SearchResource 
                :defaultSearchKey="defaultResourceKey" 
                @onChange="onChangeResource">
            </SearchResource>
            {{searchResourceResults}}
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetResourceKey(1)">Set Key By ID</button>
        </div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetResourceKey(2)">Set Key By ID & Name</button>
        </div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetResourceKey(3)">Set Key By Text</button>
        </div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetResourceKey(4)">Set Key Empty</button>
        </div>
    </div>

    <div class="row mt-2">
        <div class="col">
            <SearchDocumentFolder 
                :menuNameId="folderMenuId" 
                label="Patient Folder" 
                :defaultSearchKey="defaultFolderKey" 
                @onChange="onChangeFolder">
            </SearchDocumentFolder>
            {{searchFolderResults}}
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetFolderKey(1)">Set Key By ID</button>
        </div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetFolderKey(2)">Set Key By ID & Name</button>
        </div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetFolderKey(3)">Set Key By Text</button>
        </div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetFolderKey(4)">Set Key Empty</button>
        </div>
    </div>

    <div class="row mt-2">
        <div class="col">
            <SearchUserGroup 
                :screenName="AppScreenNames.ToDoDocReview" 
                :defaultSearchKey="defaultUserGroupKey" 
                @onChange="onChangeUserGroup">
            </SearchUserGroup>
            {{searchUserGroupResults}}
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetUserGroupKey(1)">Set Key By ID</button>
        </div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetUserGroupKey(2)">Set Key By ID & Name</button>
        </div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetUserGroupKey(3)">Set Key By Text</button>
        </div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetUserGroupKey(4)">Set Key Empty</button>
        </div>
    </div>

    <div class="row mt-2">
        <div class="col">
            <SearchApptTypeProcedure 
                :defaultSearchKey="defaultApptTypeProcedureKey" 
                @onChange="onChangeApptTypeProcedure">
            </SearchApptTypeProcedure>
            {{searchApptTypeProcedureResults}}
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetApptTypeProcedureKey(1)">Set Key By ID</button>
        </div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetApptTypeProcedureKey(2)">Set Key By ID & Name</button>
        </div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetApptTypeProcedureKey(3)">Set Key By Text</button>
        </div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetApptTypeProcedureKey(4)">Set Key Empty</button>
        </div>
    </div>

    <div class="row mt-2">
        <div class="col">
            <SearchProcedureCode 
                :defaultSearchKey="defaultCodeKey" 
                @onChange="onChangeProcedureCode">
            </SearchProcedureCode>
            {{searchProcedureCodeResults}}
        </div>
    </div>

    <div class="row mt-2">
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetCodeKey(1)">Set Key By ID</button>
        </div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetCodeKey(2)">Set Key By ID & Name</button>
        </div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetCodeKey(3)">Set Key By Text</button>
        </div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetCodeKey(4)">Set Key Empty</button>
        </div>
    </div>

    <div class="row mt-2">
        <div class="col">
            <SearchServiceLocation 
                :defaultSearchKey="defaultServiceLocationKey" 
                @onChange="onChangeServiceLocation">
            </SearchServiceLocation>
            {{searchServiceLocationResults}}
        </div>
    </div>

    <div class="row mt-2">
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetServiceLocationKey(1)">Set Key By ID</button>
        </div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetServiceLocationKey(2)">Set Key By ID & Name</button>
        </div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetServiceLocationKey(3)">Set Key By Text</button>
        </div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetServiceLocationKey(4)">Set Key Empty</button>
        </div>
    </div>

    <div class="row mt-2">
        <div class="col">
            <SearchProvider 
                :defaultSearchKey="defaultProviderKey" 
                @onChange="onChangeProvider">
            </SearchProvider>
            {{searchProviderResults}}
        </div>
    </div>

    <div class="row mt-2">
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetProviderKey(1)">Set Key By ID</button>
        </div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetProviderKey(2)">Set Key By ID & Name</button>
        </div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetProviderKey(3)">Set Key By Text</button>
        </div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetProviderKey(4)">Set Key Empty</button>
        </div>
    </div>

    <div class="row mt-2">
        <div class="col">
            <SearchLoinc
                :defaultSearchKey="defaultLoincKey" 
                @onChange="onChangeLoinc">
            </SearchLoinc>
            {{searchLoincResults}}
        </div>
    </div>

    <div class="row mt-2">
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetLoincKey(1)">Set Key By ID</button>
        </div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetLoincKey(2)">Set Key By ID & Name</button>
        </div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetLoincKey(3)">Set Key By Text</button>
        </div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-default" @click="SetLoincKey(4)">Set Key Empty</button>
        </div>
    </div>

    <div class="row mt-2">
        <div class="col">
            <SearchUserGroupMultiple 
                label="Reviewed By" 
                :defaultListName="ListNames.ReviewedByFavorites"
                @onSelected="onSelectUserGroupMultipleReviewedBy">
            </SearchUserGroupMultiple>
            {{searchUserGroupMultipleReviewedByResults}}
        </div>
    </div>
    <div class="row mt-2">
        <div class="col">
            <SearchUserGroupMultiple 
                label="Mail" 
                :defaultListName = "ListNames.MailFavorites"
                @onSelected="onSelectUserGroupMultipleMail">
            </SearchUserGroupMultiple>
            {{searchUserGroupMultipleMailResults}}
        </div>
    </div>
    <div class="row mt-2">
        <div class="col">
            <SearchMultipleBase 
                placeholder="search multiple base placeholder" 
                label="search" 
                :columns="searchColumns" 
                displayColumn="patient_name"
                :searchResults="searchResults"
                defaultErrorMessage="Please select a patient" 
                :displayErrorMessage="displayErrorMessage"
                @performSearch="performSearch"
                @onChange="onChangeMultipleBase">
            </SearchMultipleBase>        
        </div>
    </div>

</template>

